// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"614ceb76","498":"8ba0f621","703":"c34bc604","787":"2b77af99"}[chunkId] + ".chunk.js";
};